import React from "react";
import { TextField } from "@mui/material";
import { validateEmail } from "../../../constants/functions";
import { ChevronLeftArrow } from "../../../constants/icons";
import { FORGOT_PASSWORD_OTP_PAGE, SIGN_IN_MODULE } from "../../../constants/variables";
import { useAuth } from "../../../context/AuthContext";
import { extractResource } from "../../../helper/extractResource";
import { Button } from "../../UI/Button";
import {IconBtn} from "../../../atom/IconBtn/IconBtn";

function ForgotPasswordLandingPage(props) {
  const [timerId, setTimerId] = React.useState<any>(null);
  const [error, setError] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");
  const { forgetPassword, userExist } = useAuth();
  const {resourceData} = props;

  /**
   * the function validates formdata
   * sets errors if invalid
   * @param e
   */
  const main = (e: any) => {
    if (isNaN(+props.emailOrMobile)) {
      if (validateEmail(e.target.value)) {
        setErrorMsg("");
        setError(false);
      } else {
        setErrorMsg(extractResource(resourceData, "invalidEmail"));
        setError(true);
      }
    } else if (e.target.value.length !== 10) {
      setErrorMsg(extractResource(resourceData, "invalidEmail"));
      setError(true);
    }
  };

  // ? the debounce function calls the main fucntion after the specified delay after user stops typing
  const debounce = (e: any, delay: any) => {
    setError(false);

    if (timerId) {
      clearTimeout(timerId);
      setTimerId(null);
    }

    setTimerId(
      setTimeout(() => {
        main(e);
      }, delay)
    );
  };

  /**
   * the function updates the emailOrMobile state with current input value
   * it also triggers the debounce function
   * @param e
   */
  const handleChange = (e) => {
    props.setEmailOrMobile(e.target.value);

    debounce(e, 1000);
  };

  /**
   * the function validates email or mobile number before submission
   * it sets errors if invalid
   * if valid, it allows the action call
   */
  const handleSubmit = async () => {
    if (isNaN(+props.emailOrMobile) && validateEmail(props.emailOrMobile)) {
      await userExist(props.emailOrMobile).then((resp) => {
        if (resp) {
          setError(false);
          forgetPassword(props.emailOrMobile);
          props.handleState(FORGOT_PASSWORD_OTP_PAGE);
        } else {
          setErrorMsg(extractResource(resourceData, "userNotFound"));
          setError(true);
        }
      });
    }
    // else if (props.emailOrMobile.length == 10){
    //   forgetPassword("+91"+props.emailOrMobile);
    //   props.handleState(FORGOT_PASSWORD_OTP_PAGE);
    // }
    else setError(true);
  };

  // ? returns landing page of forgot password module
  return (
    <div className="w-full sm:w-80 m-auto">
      <div className="flex items-center">
        <IconBtn
          onClick={() => {
            props.handleModule(SIGN_IN_MODULE);
          }}
        >
          <ChevronLeftArrow />
        </IconBtn>

        <p className="font-semibold text-xl mx-3">{extractResource(resourceData, "forgotPassword")}</p>
      </div>

      <div className="space-y-6">
        <p className="text-base font-medium mt-6 text-typography-primary">{extractResource(resourceData, "enterMobileOrEmailToReset")}</p>
        <TextField
          error={error}
          id="outlined-error-helper-text"
          label={extractResource(resourceData, "emailId")}
          placeholder={extractResource(resourceData, "emailId")}
          defaultValue={props.emailOrMobile}
          helperText={error ? errorMsg : ""}
          onChange={handleChange}
          name="emailOrMobileOrMobile"
          fullWidth
        />
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            handleSubmit();
          }}
          fullWidth
        >
          {extractResource(resourceData, "sendOtp")}
        </Button>
      </div>
    </div>
  );
}

export default ForgotPasswordLandingPage;
